import { render, staticRenderFns } from "./ItemsComponent.vue?vue&type=template&id=3a185b8b&"
import script from "./ItemsComponent.vue?vue&type=script&lang=js&"
export * from "./ItemsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports